import { defineMessages } from 'react-intl';

export default defineMessages({
  invalid: {
    id: 'app.components.FlexChoices.invalid',
    defaultMessage: 'Item obrigatório',
  },
  maintenanceCondition: {
    id: 'app.components.ChoiceRadio.maintenanceCondition',
    defaultMessage: 'Selecione a opção que melhor descreva o imóvel',
  },
  PERFECT_STATE: {
    id: 'app.components.ChoiceRadio.PERFECT_STATE',
    defaultMessage: 'Imóvel em perfeito estado',
  },
  ALMOST_PERFECT_STATE: {
    id: 'app.components.ChoiceRadio.ALMOST_PERFECT_STATE',
    defaultMessage: 'Imóvel precisa de alguns ajustes',
  },
  NEW_OR_WITHOUT_BASIC_ITENS: {
    id: 'app.components.ChoiceRadio.NEW_OR_WITHOUT_BASIC_ITENS',
    defaultMessage: 'Imóvel recém-construído ou sem itens básicos',
  },
  POORLY_MAINTAINED: {
    id: 'app.components.ChoiceRadio.POORLY_MAINTAINED',
    defaultMessage: 'Imóvel mal conservado',
  },
  OLD: {
    id: 'app.components.ChoiceRadio.OLD',
    defaultMessage: 'Imóvel antigo bem conservado',
  },
});
